import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { defaultAuthHandler } from './auth'
import { DisconnectedOrg } from './components/Pmitc/Addon/DisconnectedOrg'
import { Org } from './components/Pmitc/Addon/Org'
import { AuthenticationCallbackRoute } from './components/routing/AuthenticationCallbackRoute'
import LandingPage from './components/routing/LandingPage'
import PrivateRouteContainer from './components/routing/PrivateRouteContainer'
import AppContainer from './routes/AppContainer'

export const MainRoutes = () => {
  return (
    <Routes>
      <Route path='/landing' element={<LandingPage />} />
      <Route path='/callback' element={<AuthenticationCallbackRoute />} />
      <Route path='/pmitc/data-centers/:dataCenter/orgs/:orgId/*' element={<Org />} />
      <Route path='/pmitc/disconnected' element={<DisconnectedOrg />} />

      <Route
        path='/*'
        element={
          <PrivateRouteContainer authHandler={defaultAuthHandler}>
            <AppContainer />
          </PrivateRouteContainer>
        }
      />
    </Routes>
  )
}
